<template>
  <div class="filter-combinator">
    {{ text }}
  </div>
</template>

<script setup lang="ts">
defineProps<{
  text: string;
}>();
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";

.filter-combinator {
  @apply w-72 text-sm text-neutral-text shrink-0 px-8 py-4 rounded-6 flex items-center justify-center cursor-default min-h-32 bg-neutral-background-disabled/50;
}
</style>
